<template>
  <div class="right-box">
    <div class="set-wx">
      <p class="no-bind" v-if="bindWx">
        <span><i class="iconfont iconweixin"></i>未绑定微信</span>
        <el-button type="primary" @click="toBind">立即绑定</el-button>
      </p>
      <p class="bind" v-else>
        <span><i class="iconfont iconweixin"></i>{{this.$store.state.user.wechat_name}}</span>
        <el-button type="primary" @click="delBind">解绑微信</el-button>
      </p>
    </div>
  </div>
</template>

<script>
  import config from '../../../config/index'
  export default {
    name: "setWx",
    data(){
      return {

      }
    },
    computed:{
      bindWx(){
        return this.$store.state.user.wechat_openid === 0 ? (true) : (false)
      }
    },
    created() {
      this.$emit('setNav', 2)
      this.init()
    },
    methods:{
      init(){
        this.$api.apiMember.ShowCandidateInfo({
          userToken: this.$store.state.user.user_token,
          isExecute : this.$store.state.user.is_execute
        }).then(res=>{
          this.$store.state.user = res.data
        }).catch(e=>{
          this.$message.error(e.info)
        })
      },
      toBind(){
        window.location.href = config.urlStr + '/index/common/wechatLogin?userToken='+this.$store.state.user.user_token
      },
      delBind(){
        this.$confirm('您确定要解除绑定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiMember.deleteBindWx({
            userToken:this.$store.state.user.user_token,
          }).then(()=>{
            this.init()
            this.$message({
              message:'解绑成功',
              type:'success'
            })
          }).catch(e=>{
            this.$message(e.info)
          })
        }).catch(() => {

        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .right-box {
    padding: 30px 0;

    .set-wx {
      width: 400px;
      margin: 0 auto;

      .no-bind {
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
          display: flex;
          align-items: center;
          line-height: 40px;
          i{
            display: block;
            width: 40px;
            text-align: center;
            line-height: 40px;
            color: #67C23A;
            font-size: 30px;
            padding-right: 20px;
          }
          b{
            display: block;
          }
        }
      }
      .bind{
        display: flex;
        align-items: center;
        justify-content: space-around;
        span{
          display: flex;
          align-items: center;
          line-height: 40px;
          i{
            display: block;
            width: 40px;
            text-align: center;
            line-height: 40px;
            color: #67C23A;
            font-size: 30px;
            padding-right: 20px;
          }
          b{
            display: block;
          }
        }

      }
    }
  }

</style>
